<template>
  <button
    v-if="isSupported"
    v-tooltip="getTooltipContent(true)"
    aria-label="Copy to Clipboard"
    @click="onCopy"
  >
    <slot />
  </button>

  <button
    v-else
    v-tooltip="getTooltipContent(false)"
    aria-label="Copy to Clipboard"
    disabled
  >
    <slot />
  </button>
</template>

<script setup>
import { computed, getCurrentInstance } from "vue";
import { useClipboard } from "@vueuse/core";
import useNotify from "@Composables/useNotify";

const $vm = getCurrentInstance()?.proxy;

const props = defineProps({
  hasTooltip: {
    type: Boolean,
    default: false,
  },

  value: {
    type: String,
    required: true,
  },
});

const { copy, isSupported } = useClipboard();

const { onCopySuccess } = useNotify();

const isOnMobile = computed(() => $vm.$store.getters.isOnMobile);

function getTooltipContent(supported) {
  const tooltip = {
    content: `Copy to Clipboard`,
    placement: "bottom",
    trigger: isOnMobile.value ? "click" : "focus hover",
  };

  if (!supported) {
    tooltip.content = `Copying to clipboard is not currently supported. Please try again later`;
  }

  if (props.hasTooltip) {
    return tooltip;
  } else {
    return {};
  }
}

function onCopy() {
  copy(props.value);
  onCopySuccess();
}
</script>
